export enum Paths {
    DEFAULT = "/",
    TEST1 = "/test1",
    TEST2 = "/test2",
    TEST3 = "/test3",
    MOBILE1 = "/mobile1",
    MOBILE2 = "/mobile2",
    MOBILE3 = "/mobile3",
}